import { z } from 'zod'

import { selectStepsSorted } from '../selectors/config'
import type { HistoryStackChangedAction } from '../types/actions'

import { actionFactory } from './factory'

export const ContextualDataSchema = z.record(z.string(), z.string()).optional()

export const historyStackChanged = actionFactory<HistoryStackChangedAction>(
  (state, { stack }) => {
    if (!stack.length) return

    const sortedSteps = selectStepsSorted(state)

    state.navigatedPath = stack.map((h) => sortedSteps[h.stepIndex].id)
  },
  'historyStackChanged'
)
